import classes from "./SectionTransition.module.css";

// A zero-height sentinel placed between two adjacent full-bleed colored homepage sections. Its
// child is absolutely positioned straddling the DOM boundary (half overlapping each section),
// bridging their colors so there's no flat white gap at the seam — without adding any extra
// height to the page layout itself (the sentinel is height:0, the glow is position:absolute).
export function SectionTransition() {
  return (
    <div className={classes.anchor}>
      <div className={classes.glow} aria-hidden="true" />
    </div>
  );
}
